import { render, staticRenderFns } from "./AdminSentInstructionsNotes.vue?vue&type=template&id=97eb7f22&scoped=true"
import script from "./AdminSentInstructionsNotes.vue?vue&type=script&lang=js"
export * from "./AdminSentInstructionsNotes.vue?vue&type=script&lang=js"
import style0 from "./AdminSentInstructionsNotes.vue?vue&type=style&index=0&id=97eb7f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eb7f22",
  null
  
)

export default component.exports